export class FileSizeException extends Error{
    constructor(message:string){
        super(message)
        this.name = "FileSizeException"
        Object.setPrototypeOf(this, FileSizeException.prototype)
    }
}

// Qa file upload
export class FileColumnException extends Error{
    constructor(message:string){
        super(message)
        this.name = "FileColumnException"
        Object.setPrototypeOf(this, FileSizeException.prototype)
    }
}
export class DuplicateQuestionException extends Error{
    constructor(message:string){
        super(message)
        this.name = "DuplicateQuestionException"
        Object.setPrototypeOf(this, FileSizeException.prototype)
    }
}